import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *proceedLoop($this, $completion) {
  $l$loop_0: do {
    var index = $this.w4v_1;
    if (index === -1) {
      break $l$loop_0;
    }
    var interceptors = $this.t4v_1;
    if (index >= interceptors.q2()) {
      $this.x4v();
      break $l$loop_0;
    }
    var executeInterceptor = interceptors.r2(index);
    $this.w4v_1 = index + 1 | 0;
    yield* executeInterceptor($this, $this.v4v_1, $completion);
  }
   while (true);
  return $this.v4v_1;
}
var DebugPipelineContextClass;
function DebugPipelineContext() {
  if (DebugPipelineContextClass === VOID) {
    class $ extends PipelineContext() {
      constructor(context, interceptors, subject, coroutineContext) {
        super(context);
        this.t4v_1 = interceptors;
        this.u4v_1 = coroutineContext;
        this.v4v_1 = subject;
        this.w4v_1 = 0;
      }
      gw() {
        return this.u4v_1;
      }
      y4v() {
        return this.v4v_1;
      }
      x4v() {
        this.w4v_1 = -1;
      }
      *z4v(subject, $completion) {
        this.v4v_1 = subject;
        return yield* this.a4w($completion);
      }
      *a4w($completion) {
        var index = this.w4v_1;
        if (index < 0)
          return this.v4v_1;
        if (index >= this.t4v_1.q2()) {
          this.x4v();
          return this.v4v_1;
        }
        return yield* /*#__NOINLINE__*/proceedLoop(this, $completion);
      }
      *b4w(initial, $completion) {
        this.w4v_1 = 0;
        this.v4v_1 = initial;
        return yield* this.a4w($completion);
      }
    }
    initMetadataForClass($, 'DebugPipelineContext', VOID, VOID, VOID, [1, 0]);
    DebugPipelineContextClass = $;
  }
  return DebugPipelineContextClass;
}
//region block: exports
export {
  DebugPipelineContext as DebugPipelineContext2zfnr2i0vcihk,
};
//endregion

//# sourceMappingURL=DebugPipelineContext.mjs.map
